import { post } from "../lib/http.js";
import { API } from "../config/api.js";
import { toTenDigitMobile } from "../utils/phone.js";

export async function sendOtp(mobile) {
  const ten = toTenDigitMobile(mobile);
  if (!ten) {
    throw new Error("Enter valid 10-digit mobile number.");
  }
  return post(API.auth.sendOtp, { mobile: ten }, {
    headers: { "Content-Type": "application/json" },
  });
}

export async function verifyOtp({ mobile, code }) {
  const ten = toTenDigitMobile(mobile);
  if (!ten) {
    throw new Error("Enter valid 10-digit mobile number.");
  }
  const payload = { mobile: ten, otp: code };
   const res = await post(API.auth.verifyMobileOtp, payload, {
    headers: { "Content-Type": "application/json" },
  });
   if (res?.token) {
    const ten = String(res.data?.mobile || "").replace(/\D/g, "").slice(-10);
    localStorage.setItem(
      "bb_user",
      JSON.stringify({
        id: res.data._id,
        name: res.data.name,
        phone: ten,
        mobile: ten,
        email: res.data.email || "",
        token: res.token,
        role: res.data.role || "user",
      })
    );
  }

  return res;
}

export async function registerUser({ name, email, phone, code }) {
  const ten = toTenDigitMobile(phone);
  if (!ten) {
    throw new Error("Enter valid 10-digit mobile number.");
  }
  const payload = {
    name,
    email,
    mobile: ten,
    otp: code,
    opt: code,
  };
  return post(API.auth.registerUserOtp, payload, {
    headers: { "Content-Type": "application/json" },
    meta: { useApiKey: true },
  });
}

export async function resendOtp(mobile) {
  return sendOtp(mobile);
}





// // src/api/auth.js
// import { post, get } from "../lib/http.js";
// import { API } from "../config/api.js";


// // Send OTP
// export async function sendOtp(mobile) {
//   // backend expects: { mobile }
//   return post(API.auth.sendOtp, { mobile });
// }

// // For LOGIN: verify OTP (we'll pass minimal name/email)
// export async function verifyOtp({ mobile, code, name = "Guest", email = "" }) {
//   // server may expect "otp" or mistakenly "opt" — send both to be safe
//   const body = { name, email, mobile, otp: code, opt: code };
//   // expected to return token/user OR just a success; our pages handle fallback
//   return post(API.auth.registerUserOtp, body);
// }

// export async function verifyMobileOTP({ mobile, code }) {
//   // server may expect "otp" or mistakenly "opt" — send both to be safe
//   const body = { mobile, otp: code, opt: code };
//   // expected to return token/user OR just a success; our pages handle fallback
//   return post(API.auth.verifyMobileOTP, body);
// }

// // verifyMobileOTP

// // For REGISTER: verify + create
// export async function registerUser({ name, email, phone, code }) {
//   const mobile = phone;
//   const body = { name, email, mobile, otp: code, opt: code };
//   return post(API.auth.registerUserOtp, body);
// }

// // Optional: current user
// export async function fetchMe() {
//   return get(API.auth.me);
// }
